module.exports = __webpack_public_path__ + "files/b986af5557eaee5cb105a230d8c14f74.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-5.png
// module id = 1487
// module chunks = 60